import script from "./ProjectCompetencies.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectCompetencies.vue?vue&type=script&setup=true&lang=js"

import "./ProjectCompetencies.vue?vue&type=style&index=0&id=ddc610f2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddc610f2"]])

export default __exports__